export enum CustomizacaoSubmenuEnum {
    colaborador = 1,
    meusPedidos = 2,
    novoPedido = 3,
    contratarNovoBeneficio = 4,
    produtosAderidos = 5,
    reajusteBeneficio = 6,
    consultarBeneficio = 7,
    gestores = 8,
    centroCusto = 9,
    unidades = 10,
    departamentos = 11,
    dadosBancarios = 12,
    dadosEmpresa = 13,
    minhasCompras = 14,
    novaCompra = 15,
}
